@if (isVisible) {
  <div class="modal-overlay" (click)="onCancel($event)">
    <div class="modal-container" (click)="stopPropagation($event)">
      <div class="modal-header">
        <h3>{{ title | translate }}</h3>
        <button class="close-btn" (click)="onCancel($event)">
          <span class="icon-close">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ message | translate }}</p>
      </div>
      <div class="modal-footer">

        <app-primary-button
          title="{{ (isLoading? 'Processing...':confirmText) | translate }}"
          (click)="onConfirm($event)"
          [disable]="isLoading"
        ></app-primary-button>

        <app-secondary-button
          title="{{ cancelText | translate }}"
          [disable]="isLoading"
          (click)="onCancel($event)"
        ></app-secondary-button>

      </div>
    </div>
  </div>
}
